import { render, staticRenderFns } from "./BusinessNameDataUpdateTaskLevel4.vue?vue&type=template&id=70db0136&scoped=true&"
import script from "./BusinessNameDataUpdateTaskLevel4.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateTaskLevel4.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateTaskLevel4.vue?vue&type=style&index=0&id=70db0136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db0136",
  null
  
)

export default component.exports